import { type AnimationRender, modalCreate, renderModalShadow, showHybridCardCreate } from '@subaio/components'
import { injectAnimationRenderProps } from '@subaio/components/src/useKeyedAnimation'

export const { ModalProvider, useModal } = modalCreate({
	types: {
		showCard: showHybridCardCreate(({ theme }) => ({
			backgroundColor: theme.color.textContrast,
			textColor: theme.color.text,
			mobileMediaQueryName: 'isMobile',
		})),
		showRaw: (content: AnimationRender<{ onClose: () => void }>, onClose) => ({
			render: injectAnimationRenderProps(content, { onClose }),
			isDismissable: true,
		}),
	},
	renderShadow: renderModalShadow,
})
